const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#D8262F',
                hover: '#BC161E'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
